module.exports = __webpack_public_path__ + "img/12-December.4a09bac8.jpg";